import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/about/block3-智能问答装饰.png")